import { render, staticRenderFns } from "./SecurityVerification.vue?vue&type=template&id=304d7fcb&scoped=true&"
import script from "./SecurityVerification.vue?vue&type=script&lang=js&"
export * from "./SecurityVerification.vue?vue&type=script&lang=js&"
import style0 from "./SecurityVerification.vue?vue&type=style&index=0&id=304d7fcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304d7fcb",
  null
  
)

export default component.exports